import React, { useLayoutEffect, useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import TitleNavBarContext from 'context/TitleNavBarContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import AddBtn from 'components/AddBtn';
import PaginationComp from 'components/Pagination';
import ListDynamicPages from 'components/ListDynamicPages';
import DynamicPageContext from 'context/DynamicPage';
import { getPages } from './reqs';
import Load from 'components/Load';
import FormDynamicPages from 'components/FormDynamicPages';

export default function DynamicPage() {
	const { i18n, t }: UseTranslationProps = useTranslation();
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { isLoad, setIsLoad, setDynamicPagesList, setIsFormOpen, isFormOpen } =
		useContext(DynamicPageContext);

	const [page, setPage] = useState(1);
	const [totalPage, setTotalPage] = useState(1);

	//busca pelas páginas
	useEffect(() => {
		(async () => {
			setIsLoad(true);
			await getPages(
				page,
				setTotalPage,
				setPage,
				setDynamicPagesList,
				handleNotify
			);

			setIsLoad(false);
		})();
	}, [page]);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({ ...value, title: 'dynamicPage.title' }));
	}, [i18n?.language]);

	return (
		<S.container>
			<AddBtn
				text={t('dynamicPage.addPage')}
				anyFunction={() => {
					setIsFormOpen(true);
				}}
			/>
			{isLoad ? (
				<S.loadBox>
					<Load text={t('dynamicPage.searchingPage')} showText />
				</S.loadBox>
			) : (
				<ListDynamicPages
					page={page}
					setPage={setPage}
					setTotalPage={setTotalPage}
				/>
			)}
			<PaginationComp
				actualPage={page}
				qtdPages={totalPage}
				getActualPage={setPage}
			/>
			{isFormOpen && (
				<FormDynamicPages
					page={page}
					setPage={setPage}
					setTotalPage={setTotalPage}
				/>
			)}
		</S.container>
	);
}
